// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__yMXgC","header":"Messages_header__34LMz"};